export function createAPIGatewayUrlV2(path: string) {
  switch (process.env.VUE_APP_API_ENDPOINT) {
    case "production":
      return (
        "https://raovdtkog7.execute-api.ap-northeast-1.amazonaws.com/prod/" +
        path
      );
    default:
      return (
        "https://c9cojnchph.execute-api.ap-northeast-1.amazonaws.com/dev/" + path
      );
  }
}
